export class SecurityLevel {
    ID?: number;
    Name?: string;
}

export default SecurityLevel;